const MENU_TYPES = {
    BALANCE: "balance",
    CDR: "cdr",
    USER_MAPPING: "user-mapping",
    SETTINGS: "settings",
    AUTOMATIONS: "automations",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.BALANCE,
        label: "Bakiye",
        icon: {
            type: "material-icons",
            name: "account_balance_wallet",
        },
        group: "Ana Ayarlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.CDR,
        label: "Arama Kayıtları",
        icon: {
            type: "material-icons",
            name: "record_voice_over",
        },
        group: "Ana Ayarlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.USER_MAPPING,
        label: "Kullanıcı Eşleştirme",
        icon: {
            type: "material-icons",
            name: "person",
        },
        group: "Ana Ayarlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.SETTINGS,
        label: "Ayarlar",
        icon: {
            type: "material-icons",
            name: "settings",
        },
        group: "Ana Ayarlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.AUTOMATIONS,
        label: "Otomasyonlar",
        icon: {
            type: "component",
            name: "atomic-power",
            class: "myIcon",
            style: { fill: "var(--color-icon-primary-default)" },
        },
        group: "Ana Ayarlar",
    },
];

export default {
    MENU_TYPES,
    Items,
}; 